import { FormControl, Stack } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import { Fragment } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Span from "../../../../../../components/display/Span";

export default function RemovePetFromboxConfirmation() {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Fragment>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        m={1}
      >
        <Span text={t("RemovePetConfirmationMessage")} textAlign={"center"} />
      </Stack>

      <Stack spacing={2} sx={{ mt: 2, p: 1 }}>
        <Controller
          name="dateOfExit"
          control={control}
          rules={{ required: t("EmptyField") }}
          render={({ field: { onChange, value } }) => (
            <FormControl fullWidth error={!!errors.dateOfExit}>
              <MobileDatePicker
                label={t("DateOfExit")}
                value={value}
                onChange={onChange}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error: !!errors.dateOfExit,
                    helperText: errors.dateOfExit?.message,
                  },
                }}
              />
            </FormControl>
          )}
        />
      </Stack>
    </Fragment>
  );
}
